import { NgModule } from '@angular/core';
import {CommonModule} from "@angular/common";
import {RouterModule} from '@angular/router';
import {SharedCoreModule} from '@shared/shared-core.modules';
import {VideoListComponent} from '@shared/modules/shared-videos/components/video-list/video-list.component';
import {SharedSliderModule} from '@shared/modules/shared-slider/shared-slider.module';
import {VideoPreviewCardComponent} from '@shared/modules/shared-videos/components/video-preview-card/video-preview-card.component';
import {LibLazyImageModule} from '@components/image/modules/lazy-image/lib-lazy-image.module';
import {LibUtilsPipesModule} from '@utils/pipes/lib-utils-pipes.module';

@NgModule({
  declarations: [
    VideoListComponent,
    VideoPreviewCardComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedCoreModule,
    SharedSliderModule,
    LibLazyImageModule,
    LibUtilsPipesModule,
  ],
  exports: [
    VideoListComponent,
    VideoPreviewCardComponent
  ]
})
export class SharedVideosModule { }
